/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 * 
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { ModuleWithProviders, NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';

import { ConfigService, ConfigServiceSetup, ConfigServiceFactory } from './config.service';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: ConfigServiceFactory,
            deps: [ConfigService],
            multi: true
        }
    ]
})
export class ConfigModule {

    static forRoot(config: ConfigServiceSetup): ModuleWithProviders {
        return {
            ngModule: ConfigModule,
            providers: [
                { provide: ConfigServiceSetup, useValue: config }
            ]
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: ConfigModule) {
        if (parentModule) {
          throw new Error(
            'ConfigModule is already loaded. Import it in the AppModule only');
        }
    }

}




// WEBPACK FOOTER //
// ./src/config/config.module.ts